import axios from "axios";

export function encodeQueryParams(params: Record<string, any>) {
    return new URLSearchParams(params).toString()
}


export function getAuthToken(): string {
    const OIDC_AUTHORITY = process.env.REACT_APP_OIDC_AUTHORITY || "http://localhost:8080/realms/app"
    const OIDC_CLIENT_ID = process.env.REACT_APP_OIDC_CLIENT_ID || "public-app"
    const authData = sessionStorage.getItem(`oidc.user:${OIDC_AUTHORITY}:${OIDC_CLIENT_ID}`);
    return authData ? JSON.parse(authData)?.access_token : ""
}

export function getClientId() {
    return process.env.REACT_APP_API_CLIENT_ID;
}


export function getCommonHeaders() {
    return {
        'Content-Type': 'application/json',
    }
}

export function getAuthorizationHeader() {
    return {
        'Authorization': `Bearer ${getAuthToken()}`
    }
}

export const httpClient = axios.create({
    baseURL: process.env.REACT_APP_API_HOST,
    headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },
});

export function getCategory(slug: string) {
    const endpoint = `/category/${slug}`
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint
    return httpClient.get(URL, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}

export function getProducts(slug: string) {
    const endpoint = `/product`
    const queryString = encodeQueryParams({
        slug
    })
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint + "?" + queryString
    return httpClient.get(URL, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}

export function getPackages(slug: string) {
    const endpoint = `/package`
    const queryString = encodeQueryParams({
        slug
    })
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint + "?" + queryString
    return httpClient.get(URL, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}


export function getPackageOrProduct(slug: string, type: 'Package' | 'Product') {

    const endpoint = type === 'Product' ? `/product/available` : type === 'Package' ? '/package/available' : null;
    if (!endpoint) {
        throw new Error('invalid resource type must one of Package, Product')
    }
    const queryString = encodeQueryParams({
        slug
    })
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint + "?" + queryString
    return httpClient.get(URL, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}


export function registerProductManagerUser() {
    const endpoint = '/user/register'
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint
    return httpClient.post(URL, {}, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}


export function createCart() {
    const endpoint = '/cart'
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint
    return httpClient.post(URL, {}, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}


export function addLineToCart(cartId: number, params: {
    isPackage: true,
    packageId: number,
    quantity: number,
    metadata: Record<string, string>
    selectedPackageAttributesIds?: number[]
} | {
    isPackage: false,
    productId: number,
    quantity: number
    metadata: Record<string, string>
    selectedProductAttributesIds?: number[]
}) {
    const endpoint = `/cart/${cartId}/line/add`
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint
    return httpClient.post(URL, params, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}

export function removeLineFromCart(cartId: number, params: {
    packageId: number,
} | {
    productId: number,
}) {
    const endpoint = `/cart/${cartId}/line/remove`
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint
    return httpClient.post(URL, params, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}

export function createCheckout(cartId: number) {
    const endpoint = '/checkout'
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint
    return httpClient.post(URL, {
        cartId
    }, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}

export function payCheckout(checkoutId: number) {
    const endpoint = `/checkout/${checkoutId}/pay`
    const URL = process.env.REACT_APP_PRODUCT_MANAGER_ROOT_API_URL + endpoint
    return httpClient.post(URL, {

    }, {
        headers: { ...getCommonHeaders(), ...getAuthorizationHeader() }
    }).then(({ data }) => data)
}